// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1DXSmy4hZbh0Hri6CO8FeD","form":"_1PVzi2hbA68snZfzH8s-U5"};